import { Link, useLocation } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { LEGAL_PAGES } from "@/content/legal/pages";

export function LegalPage() {
  const slug = useLocation().pathname.replace(/^\//, "");
  const page = LEGAL_PAGES[slug];

  if (!page) {
    return (
      <div className="min-h-screen flex items-center justify-center px-4 py-24">
        <Card className="max-w-lg w-full">
          <CardContent className="pt-6">
            <p className="text-muted-foreground">Page not found.</p>
            <Link to="/" className="text-primary text-sm mt-4 inline-block">
              Home
            </Link>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen px-4 py-24 max-w-3xl mx-auto" data-testid={`legal-${slug}`}>
      <Card>
        <CardHeader>
          <CardTitle className="font-heading text-2xl">{page.title}</CardTitle>
          <p className="text-xs text-muted-foreground">Last updated {page.updated}</p>
        </CardHeader>
        <CardContent className="space-y-6 text-sm text-muted-foreground leading-relaxed">
          {page.sections.map((s) => (
            <section key={s.heading}>
              <h2 className="text-foreground font-medium mb-2">{s.heading}</h2>
              <p>{s.body}</p>
            </section>
          ))}
          <p className="pt-4 border-t text-xs">© 2026 VedaPath OS. All Rights Reserved.</p>
        </CardContent>
      </Card>
    </div>
  );
}
